import React from "react";

// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function InProgress() {
    const classes = useStyles();

    return (
        <div>
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary">
                            <h4 className={classes.cardTitleWhite}>Applications In Progress</h4>
                        </CardHeader>
                        <CardBody>
                            <Table
                                tableHeaderColor="primary"
                                tableHead={["Application", "Status", "Last Activity"]}
                                tableData={[
                                    ["Awesome Security Services", "Ready For Submission", "24.07.2020"],
                                    ["Foobar Pty Ltd.", "Pending Signature", "23.07.2020"],
                                    ["Astracorp Australia Pty Ltd", "Not Completed", "23.07.2020"],
                                    ["V96 & Company Pty Ltd", "Pending Signature", "20.07.2020"]
                                ]}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
};